import { TbCategory } from 'react-icons/tb';
import { BiSolidCategoryAlt } from 'react-icons/bi';
import { FaRegUser, FaUser, FaMusic } from 'react-icons/fa';
import { CiMusicNote1 } from 'react-icons/ci';
import { FaFileAlt, FaFile } from 'react-icons/fa';
import { FaCreditCard, FaWallet } from 'react-icons/fa';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
const Menuitems = [
  // {
  //   navlabel: true,
  //   subheader: 'Navigator',
  // },
  // {
  //   id: 20,
  //   title: 'Dashboard',
  //   icon: DashboardOutlinedIcon,
  //   selectedIcon: DashboardRoundedIcon,
  //   href: '/dashboard',
  // },
  {
    id: 21,
    title: 'Masters',
    icon: AccountTreeIcon, // Ensure you are using the correct icon
    selectedIcon: AccountTreeIcon,
    href: '/masters',
    children: [
      {
        id: 6,
        title: 'Category',
        icon: TbCategory,
        selectedIcon: BiSolidCategoryAlt,
        href: '/masters/category/list',
      },
      {
        id: 11,
        title: 'User',
        icon: FaRegUser,
        selectedIcon: FaUser,
        href: '/masters/user/list',
      },
      {
        id: 12,
        title: 'Lecture',
        icon: CiMusicNote1,
        selectedIcon: FaMusic,
        href: '/masters/lectures/list',
      },
    ],
  },
  {
    id: 22,
    title: 'Report',
    icon: FaFileAlt, // Ensure you are using the correct icon
    selectedIcon: FaFile,
    href: '/reports',
    children: [
      {
        id: 6,
        title: 'Payment Report',
        icon: FaCreditCard,
        selectedIcon: FaWallet,
        href: '/reports/payment-list/list',
      },
    ],
  },
];

export default Menuitems;
